import React from "react";
import GADashboardContainer from "../../modules/GADashboard/containers/GADashboardContainer/GADashboardContainer";

const GADashboard = () => {
  return <GADashboardContainer />;
};

export default GADashboard;
